import { useTranslation } from 'react-i18next'

import { PageBody } from '~/components/common/PageBody'
import { PageLayout } from '~/components/common/PageLayout'
import { RegionLoading } from '~/components/common/RegionLoading'
import { JepxFeeSection } from '~/pages/AdminJepxMemberInfo/components/JepxFeeSection'
import { JepxMemberInfoBanner } from '~/pages/AdminJepxMemberInfo/components/JepxMemberInfoBanner'
import { JepxMemberSection } from '~/pages/AdminJepxMemberInfo/components/JepxMemberSection'
import { useGetJepxMemberInfo } from '~/pages/AdminJepxMemberInfo/hooks/useGetJepxMemberInfo'
import { routePaths } from '~/routes/routePaths'

/**
 * JEPX会員情報管理 (`docs/specs/admin/integration/jepx-member-info.md`)。
 *
 * JEPX 連携に必要なマスタ情報 (会員情報 + 料金・手数料) を集約表示する
 * **閲覧専用**画面 (AC-IJM-001)。 会員情報の登録・変更は運営側オペレーションで
 * 行うため、 本画面には登録・編集・削除の UI が一切存在しない。
 *
 * 発注主体区分別の受渡契約コードも本画面では扱わない — 入札時に広域マスタ
 * (発電 = 計画提出者マスタ / 需要BG・自己託送BG = BGマスタ) から自動解決する。
 */
export const AdminJepxMemberInfoPage = (): React.ReactElement => {
  const { t } = useTranslation()
  const { data, isLoading } = useGetJepxMemberInfo()

  const isInitialLoading = isLoading && data === undefined

  return (
    <PageLayout
      breadcrumbItems={[
        {
          label: t('page:adminJepxMemberInfo.breadcrumb.admin'),
          to: routePaths.adminHub.path,
        },
        { label: t('page:adminJepxMemberInfo.breadcrumb.page'), bold: true },
      ]}
      notices={<JepxMemberInfoBanner />}
    >
      <PageBody>
        <RegionLoading
          flexDirection="column"
          gap={4}
          display="flex"
          isLoading={isInitialLoading}
        >
          {isInitialLoading ? null : (
            <>
              <JepxMemberSection memberInfo={data?.memberInfo} />
              <JepxFeeSection feeSchedule={data?.feeSchedule} />
            </>
          )}
        </RegionLoading>
      </PageBody>
    </PageLayout>
  )
}
